export class InjectionToken {
  static IAuthenticationsRepository = Symbol("IAuthenticationsRepository");
  static IGeneralRepository = Symbol("IGeneralRepository");
  static LoginViewModel = Symbol("LoginViewModel");
  static IUserManagementRepository = Symbol("IUserManagementRepository");
  static IAppTransactionRepository = Symbol("IAppTransactionRepository");
  static PackageRegistrationViewModel = Symbol("PackageRegistrationViewModel");
  static ICarrierRepository = Symbol("ICarrierRepository");
  static IPackageRegistrationRepository = Symbol(
    "IPackageRegistrationRepository"
  );
  static INiceSimRegistrationRepository = Symbol(
    "INiceSimRegistrationRepository"
  );
  static NiceSimRegistrationViewModel = Symbol("NiceSimRegistrationViewModel");
  static IMobiSimRegistrationRepository = Symbol(
    "IMobiSimRegistrationRepository"
  );
  static MobiSimRegistrationViewModel = Symbol("MobiSimRegistrationViewModel");
  static ITravelSimRegistrationRepository = Symbol(
    "ITravelSimRegistrationRepository"
  );
  static TravelSimRegistrationViewModel = Symbol(
    "TravelSimRegistrationViewModel"
  );
  static OutboundRegistrationViewModel = Symbol(
    "OutboundRegistrationViewModel"
  );
  static IAirTimeRegistrationRepository = Symbol(
    "IAirTimeRegistrationRepository"
  );
  static ApiDocumentViewModel = Symbol("ApiDocumentViewModel");
  static AirTimeRegistrationViewModel = Symbol("AirTimeRegistrationViewModel");
  static ISupportFeatureRepository = Symbol("ISupportFeatureRepository");
  static SupportFeatureViewModel = Symbol("SupportFeatureViewModel");
  static IFilterFeatureRepository = Symbol("IFilterFeatureRepository");
  static ICashFlowRepository = Symbol("ICashFlowRepository");
  static CashFlowViewModel = Symbol("CashFlowViewModel");
  static INotificationRepository = Symbol("INotificationRepository");
  static NotificationViewModel = Symbol("NotificationViewModel");
}
